<template>
  <div class="ptrl-22-16 box-s fz-14 fw-500 mb-10">
    <div class="l-h-14 c1 mb-18">标题内容</div>
      <ul class="flex-wrap text-center">
       <li class="wh_36 every_a b-radius-50 l-h-36 mr-15 mb-22" v-for="(item, index) in list" :key="index" :class="{ blue: item == 1, red: item == 2, gray: item == 0 }" @click="getEvery(index)">{{index + 1}}</li>
      </ul>

      <div class="flexs flex-center c0 fz-12 mr-18">
        <div class="flexs mrb-26">
          <div class="wh_8 b-radius-50 bg_49 "></div>
          <div class="ml-8">答对</div>
        </div>
        <div class="flexs mrb-26">
          <div class="wh_8 b-radius-50 bg_3c"></div>
          <div class="ml-8">答错</div>
        </div>
        <div class="flexs">
          <div class="wh_8 b-radius-50 wh_bg"></div>
          <div class="ml-8">未答</div>
        </div>
      </div>
      <div class="btn_contain">
        <div class="card_btn" @click="returnPage">
        返回上一页
      </div>
    </div>
    </div>
</template>
<script>

	// import api from '@/api/api';
	import {getShowPadding} from "@/utils/common.js";
	export default {
		components: {
		},
		data() {
			return {
				padShow: false,
        list: []
			};
		},
		created() {
      const answerdata = `${this.$route.query.answerdata}`
      this.list = answerdata.length == 0? []: (answerdata.length == 1? [answerdata]: answerdata.split(','))
		},
		mounted(){
      this.padShow = getShowPadding()
		},
		methods: {
      // 返回上一页
			returnPage(){
        this.$router.replace({ path: '/passanalysis', query: { gate_level_user_id: this.$route.query.gate_level_user_id, qusetNum: this.$route.query.qusetNum } })
      },
      // 点击题返回页面做题
      getEvery(index){
        this.$router.replace({ path: '/passanalysis', query: { gate_level_user_id: this.$route.query.gate_level_user_id, qusetNum: (index + 1) } })
      },

		}
	};
</script>
<style lang="less" scoped>
.wh_bg {
  background: #FFFFFF;
  border: 1px solid #999;
}

.every_a:nth-child(7n) {
  margin-right: 0;
}

</style>
